import React from "react";
import { TrendingListItemTemplate } from "themes/administration/analytics/components";

function TrendingListItem(props) {
    return <TrendingListItemTemplate {...props} />;
}

export default TrendingListItem;
